<template>
  <div class="text-center">
    <div>
      <iconpark-icon name="pay-succ" class="text-[56px]"></iconpark-icon>
    </div>
    <div class="mt-[16px] font-medium text-font-1 text-[20px] leading-[28px]">
      {{ $t('tuan-dui-ru-men-ban-gou-mai-cheng-gong') }}
    </div>
    <div class="mt-[10px] text-font-40">
      <span>{{
        $t(
          'nin-yi-zhu-ce-cheng-gong-kuai-lai-kai-shi-ni-de-3d-shi-pin-chuang-zuo-zhi-lv-ba'
        )
      }}</span>
    </div>
    <Intro :list="data" class="text-left">
      <div class="mt-[30px]">
        <a-button
          v-if="!isGlobalVersion()"
          type="primary"
          ghost
          class="w-[102px] mr-[20px]"
          @click="goLink(PageKey.ACCOUNT_VERIFY)"
        >
          <a-popover :title="$t('ren-zheng-quan-yi-dui-bi')">
            <template #content>
              <CertificationCompare />
            </template>
            <iconpark-icon
              name="info"
              class="mr-[8px] align-middle"
            ></iconpark-icon>
          </a-popover>
          <span v-if="isChinese()" class="align-middle">
            {{ $t('qu-ren-zheng') }}
          </span>
        </a-button>
        <a-button type="primary" class="w-[102px]" @click="goLink('home')">
          {{ $t('kai-shi-you-yan') }}
        </a-button>
      </div>
    </Intro>
    <XAttract :source="AttractSource.TEAM_PAYMENT" type="fixed" />
  </div>
</template>
<script lang="ts" setup>
import Intro from '~/features/intro/index.vue'
import { CertificationCompare } from '~/features/certificationCompare'
import { useClient } from '~/hooks/useClient'
import type { CreateStarterOrgResponse, LoginInfo } from '~/api/interface'
import { TEAM_STARTER_PAY_ACCOUNT_KEY } from '~/constants/teamCreate'
import { getUserToken } from '~/api'
import { sessionRemoveItem } from '~/utils/localStorage'
import XAttract from '~/components/xAttract/index.vue'
import { AttractSource } from '~/components/xAttract/constant'
import { BROADCAST_KEY, COOKIE_KEY } from '~/constants/config'
import { PageKey } from '~/constants/page'

type CardInfo = {
  url: string
  name: string
  desc: string
}

const { $t } = useNuxtApp()
const { setSession } = useChangeUser()

const data: CardInfo[] = [
  {
    url: getFeUrl('/youyan-platform/png/team_admin.png'),
    name: $t('tuan-dui-guan-li'),
    desc: $t('yao-qing-cheng-yuan-jia-ru-fen-xiang-zuo-pin-xie-zuo'),
  },
  {
    url: getFeUrl('/youyan-platform/png/team_space.png'),
    name: $t('tuan-dui-kong-jian'),
    desc: $t('tuan-dui-gong-xiang-kong-jian-quan-yuan-nei-rong-ke-jian'),
  },
  {
    url: getFeUrl('/youyan-platform/png/team_specification.png'),
    name: $t('pin-pai-gui-fan'),
    desc: $t('wei-hu-pin-pai-gui-fan-tong-yi-qi-ye-xing-xiang'),
  },
]

const goLink = (name: string) => {
  navigateTo({
    name,
  })
}

useUpdateAccountList()

const starterOrgRes = useClient<CreateStarterOrgResponse>(() =>
  sessionGetItem(TEAM_STARTER_PAY_ACCOUNT_KEY)
)

function updateCustomSetting(userInfo: any) {
  CustomSettingApp.initAvatar(userInfo.logo_url, userInfo.default_logo_url)
  CustomSettingApp.initLogo(
    userInfo.platform_logo_url,
    userInfo.default_platform_logo_url
  )
}

onMounted(async () => {
  if (!starterOrgRes.value?.user_id) {
    return
  }

  trackEvent(TRACK_EVENT.TEAM_PAYMENT_SUCCESS)

  const { data } = await getUserToken(starterOrgRes.value!.user_id) // 获取LoginInfo
  const account = data?.[0] as LoginInfo
  sensorsLogin(Number(account.user_id))

  await setSession(account) // 更新当前账户

  updateCustomSetting(account) // 更新头像和logo

  emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })
  // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
  //   cookieValue: JSON.parse(JSON.stringify(account)),
  // })
  sessionRemoveItem(TEAM_STARTER_PAY_ACCOUNT_KEY)
})
</script>
<style lang="scss" scoped>
.card {
  @apply px-[16px] py-[30px] bg-back-1;
  transition: all 3s ease-in-out;
  &:hover {
    background: linear-gradient(
      to right bottom,
      #e1fff9 0%,
      #f5feff 33%,
      #ffffff 66%,
      #d8d5ff 100%
    );
  }
}
</style>
